import { render, staticRenderFns } from "./_url.vue?vue&type=template&id=6f1b1358&"
import script from "./_url.vue?vue&type=script&lang=js&"
export * from "./_url.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseProfileStreamCoverSelf: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Base/Profile/Stream/Cover/Self.vue').default,BaseProfileStreamCover: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Base/Profile/Stream/Cover/Cover.vue').default,BaseProfileStreamHeader: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Base/Profile/Stream/Header.vue').default,BaseRecommendationsStreamExperts: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Base/Recommendations/Stream/Experts.vue').default,BaseRecommendationsStreamMaterialsBlock: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Base/Recommendations/Stream/Materials/Block.vue').default,BaseRecommendationsStreamVideoBlock: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Base/Recommendations/Stream/Video/Block.vue').default,MegasredaRecomendedSocial: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Megasreda/Recomended/Social/Social.vue').default,BaseProfileStreamLayout: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Base/Profile/Stream/Layout.vue').default})
